import { Grid } from '@mui/material'

import { AppBox, AppImage, AppTypography } from 'components'
import { appRoutes } from 'globals/constants'
import { useNavigate } from 'react-router-dom'
import { SignUpForm } from './signup-form.tsx/SignUpForm'
import { SignUpPlans } from './signup-plans/SignUpPlans'
import { Helmet } from 'react-helmet-async'

export const SignUp = () => {
  const navigate = useNavigate()
  const handleLoginClick = () => {
    navigate(appRoutes.login.path)
  }
  return (
    <>
      <Helmet>
        <title>Sign in to your ParkSitesIO account</title>
        <meta
          name="description"
          content="Sign in to your ParkSitesIO account to manage your mobile home park sheets."
        />
        <meta name="robots" content="index, follow" />

        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'WebPage',
            headline: 'Sign up for a new ParkSitesIO account',
            url: 'https://app.parksites.io/signup',
            image:
              'https://cdn.prod.website-files.com/65b7c6a8abe85fd988ba381c/67e2af21ac0761f5986a6f32_sign-up-to-parksitesio--min.png',
            description: 'Create a new ParkSitesIO account today to start curing your mobile home park sheets.',
            publisher: {
              '@type': 'Organization',
              name: 'ParkSitesIO, LLC',
              url: 'https://www.parksites.io',
              sameAs: [
                'https://www.facebook.com/parksitesio',
                'https://www.linkedin.com/company/parksitesio',
                'https://www.youtube.com/@ParkSitesIO',
              ],
              logo: 'https://cdn.prod.website-files.com/65b7c6a8abe85fd988ba381c/65c91efbb980349c04d0aa23_ParkSitesIO-logo-black-.png',
              email: 'support@parksites.io',
            },
          })}
        </script>
      </Helmet>
      <Grid container height={'100vh'} sx={{ backgroundColor: 'grey.50' }}>
        <Grid item xs={12} md={6} paddingX={4} paddingY={2}>
          <AppImage src="/images/logo/logo-black.png" alt="nature" height={40} />
          <Grid container justifyContent={'center'} alignItems={'center'} paddingTop={5}>
            <Grid item xs={8}>
              <AppBox display={'flex'} gap={1} flexDirection={'column'}>
                <AppTypography fontSize={40} fontWeight={700} color={'grey.900'}>
                  Sign up to start your free trial
                </AppTypography>
                <AppTypography fontSize={16}>
                  Sign up for our 7-day free trial. No credit card required. To access an existing account, simply
                  <AppTypography component={'a'} fontSize={16} isColorPrimary onClick={() => handleLoginClick()}>
                    {' '}
                    sign in.
                  </AppTypography>
                </AppTypography>
                <SignUpForm />
              </AppBox>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <SignUpPlans />
        </Grid>
      </Grid>
    </>
  )
}
